import React from 'react';
import PropTypes from 'prop-types';
// common components
import CustomAvatar from './../../../common/Avatar/Avatar';
import Breadcrumb from './../../../common/Breadcrumb/Breadcrumb';

const CourseDetails = ({courseDetails, links, moduleLength}) => (
	<div className='CourseDetails detailed-view'>
		<div className="Module-image">
			<CustomAvatar name={courseDetails.name} />
		</div>
		<div className="details">
			<div className="row detailed-card">
				<div className="col-8 card-heading">
				
					<div className="heading">
						<div className="title">{courseDetails.name}</div>
						<div className="desc">{courseDetails.description}</div>
					</div>
				</div>
				<div className="col bread-crumb">
					<Breadcrumb links={links} />
				</div>
			</div>
			<div className="row card-details">
				{/*<div className="col">
					<div className="title">created by</div>
					<div className="value">Jayaprakash</div>
				</div>
				<div className="col">
					<div className="title">created date</div>
					<div className="value">15 Feb 2019</div>
				</div>*/}
				{moduleLength > 0 && <div className="col">
					<div className="title"># of modules</div>
					<div className="value">{moduleLength}</div>
				</div>}
			</div>
		</div>
	</div>
);

CourseDetails.propTypes = {
	courseDetails: PropTypes.instanceOf(Object),
	links: PropTypes.instanceOf(Array),
	moduleLength: PropTypes.number
};

CourseDetails.defaultProps = {
	courseDetails: {},
	links: [],
	moduleLength: 0
};

export default CourseDetails;


// WEBPACK FOOTER //
// ./components/CourseModule/CourseDetails/CourseDetails.js